import axios from 'axios'

export const startOutboundCall = async (leadId) => {
  return axios.post('/api/call/start-outbound', { leadId }).then((res) => res.data)
}

export const getNumbersList = async () => {
  return axios.get('/api/call/aircall-numbers').then((res) => res.data)
}

export const getOngoingCall = async () => {
  return axios.get(`/api/call/ongoing`).then((res) => res.data)
}

export const answerInboundCall = async ({ bypassProcessingLeadCheck = false, bypassUntaggedLeadCheck = false }) => {
  return axios
    .post(`/api/call/inbound/answer`, { bypassProcessingLeadCheck, bypassUntaggedLeadCheck })
    .then((res) => res.data)
}

export const tagACall = async ({ leadId, callId, callProcessTagId, details, comment }) => {
  return axios.post(
    `/api/calls/tag`,
    {
      leadId: leadId || null,
      callId: callId || null,
      callProcessTagId,
      details,
      comment,
    }).then((res) => res.data)
}

export const forceEndCall = async (callId) => {
  return axios.post(`/api/call/force-end`, { callId }).then((res) => res.data)
}

export default {
  startOutboundCall,
  getNumbersList,
  getOngoingCall,
  answerInboundCall,
  tagACall,
  forceEndCall,
}
